import { render } from "./TeamSetup.vue?vue&type=template&id=ae29fc9a"
import script from "./TeamSetup.vue?vue&type=script&lang=js"
export * from "./TeamSetup.vue?vue&type=script&lang=js"

import "./TeamSetup.vue?vue&type=style&index=0&id=ae29fc9a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__